import { useEffect, useState } from "react";
import type {
    IContainerTypeLookupItem,
    IHazardousPropertyCodeLookupItem,
    IPopCodeLookupItem,
    IRegEwcLookupItem,
    IRegGeographyLookupItem,
    IRegLookupItem,
    IRegMunicipalDegradableLookupItem,
} from "@/customTypings/wasteMovement/WasteMovement";
import { authHeader, handleResponse } from "@/utils";
import type { WasteMovementReferenceLookups } from "../model/referenceLookups";

export function useWasteMovementReferenceLookups() {
    const [lookups, setLookups] = useState<WasteMovementReferenceLookups | null>(null);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const headers = authHeader();
        const opts: RequestInit = { method: "GET", headers, credentials: "include" };
        Promise.all([
            fetch("/api/referencedata/Ewcs", opts).then(handleResponse) as Promise<IRegEwcLookupItem[]>,
            fetch("/api/referencedata/Geographies", opts).then(handleResponse) as Promise<IRegGeographyLookupItem[]>,
            fetch("/api/referencedata/DisposalRecoveryCodes", opts).then(handleResponse) as Promise<IRegLookupItem[]>,
            fetch("/api/referencedata/PhysicalStates", opts).then(handleResponse) as Promise<IRegLookupItem[]>,
            fetch("/api/referencedata/MunicipalDegradables", opts).then(handleResponse) as Promise<IRegMunicipalDegradableLookupItem[]>,
            fetch("/api/referencedata/SourceActivities", opts).then(handleResponse) as Promise<IRegLookupItem[]>,
            fetch("/api/referencedata/PreTreatments", opts).then(handleResponse) as Promise<IRegLookupItem[]>,
            fetch("/api/referencedata/ContainerTypes", opts).then(handleResponse) as Promise<IContainerTypeLookupItem[]>,
            fetch("/api/referencedata/HazardousPropertyCodes", opts).then(handleResponse) as Promise<IHazardousPropertyCodeLookupItem[]>,
            fetch("/api/referencedata/PopCodes", opts).then(handleResponse) as Promise<IPopCodeLookupItem[]>,
        ])
            .then(
                ([
                    ewcs,
                    geographies,
                    disposalRecoveryCodes,
                    physicalStates,
                    municipalDegradables,
                    sourceActivities,
                    preTreatments,
                    containerTypes,
                    hazardousPropertyCodes,
                    popCodes,
                ]) => {
                    setLookups({
                        ewcs,
                        geographies,
                        disposalRecoveryCodes,
                        physicalStates,
                        municipalDegradables,
                        sourceActivities,
                        preTreatments,
                        containerTypes,
                        hazardousPropertyCodes,
                        popCodes,
                    });
                }
            )
            .catch(() => setError("Could not load reference data."));
    }, []);

    return { lookups, error };
}
